import angular from 'angular';
import onboardingNavigation from './onboardingNavigation';
import './style.scss';

export default angular
  .module('components.onboardingNavigation', [])
  .component('onboardingNavigation', onboardingNavigation).name;
